import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react';
import { AppContextData, AppLayoutContextProvider } from './AppLayoutContext';

export type RootProps = SimpleGridProps & AppContextData;

export const Root = (props: RootProps) => {
  const { variant, bg, ...rest } = props;

  return (
    <AppLayoutContextProvider variant={variant}>
      <SimpleGrid
        columns={[1, 1, 2]}
        spacing={0}
        minH="100vh"
        minW="100vw"
        gridAutoRows="auto"
        bg={variant === 'error' ? 'error.500' : bg}
        {...rest}
      />
    </AppLayoutContextProvider>
  );
};
